__turbopack_context__.v({
  "main": "LorryOneLineInfo-module-scss-module__byjP1a__main",
  "wrapper": "LorryOneLineInfo-module-scss-module__byjP1a__wrapper",
});
